import {Component, OnInit, Injectable} from '@angular/core';
import {Stormpath, defaultSpTokenResolver} from 'angular-stormpath';
import {Location} from '@angular/common';

@Component({
    template: require('./verify-registration-page.component.html'),
    styles: [require('./verify-registration-page.component.scss')]
})
@Injectable()
export class VerifyRegistrationPageComponent implements OnInit {
    protected error: string;
    protected verifying: boolean;
    protected verified: boolean;
    protected verificationFailed: boolean;
    protected sptoken: string;

    constructor(public stormpath: Stormpath, public location: Location) {
    }

    ngOnInit() {
        this.verifying = false;
        this.verified = false;
        this.verificationFailed = false;
        this.sptoken = this.spTokenResolver();
        if (this.sptoken) {
            this.verify();
        }
    }

    spTokenResolver(): string {
        return defaultSpTokenResolver(this.location);
    }

    verify() {
        this.verifying = true;
        this.stormpath.verifyEmailVerificationToken(this.sptoken)
            .subscribe(() => {
                this.verifying = false;
                this.verified = true;
            }, (error) => {
                this.verifying = false;
                this.verificationFailed = true;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/register/verify/verify-registration-page.component.ts